<div>
    <div style="margin-left: 80%;  margin-bottom: 2%">
        <!-- <button [useExistingCss]="true" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" printTitle="Label" printSectionId="print-section" ngxPrint>
            print
        </button> -->

          <button [useExistingCss]="true"
            style="margin-right: 2%; margin-left: 2%; z-index: 10; font-size: 12px; font-weight: 600;"
            mat-raised-button color="primary" printSectionId="print-section" ngxPrint>
      Print
    </button>
        <button mat-dialog-close class="btn noPrint">Close</button>
    </div>
    <div class="container" id="print-section">
        <!-- <div class="row">
            <div class="col-6">
                <div class="col-3">
                    <img src="../../../assets/img/brand/red.png" alt="" width="100">
                </div>
                <div class="col-9">

                </div>
            </div>
        </div> margin-bottom: 4%;margin-top: 1.5%; -->

        <table class="wrapper">
  <thead>
    <tr>
      <td>
        <!-- <div class="header">&nbsp; दि. {{ data.formattedDate | date:'dd/MM/yyyy' }}  साप्तहिक विवेक</div> -->
        <h3 class="print-header" style="font-size: 15px; font-weight: 600; text-align: left;">
         दि. {{ today | date:'dd/MM/yyyy hh:mm:ss' }}  साप्तहिक विवेक - वर्गणी जमा असलेले  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
          वितरक नाव : {{ data.dist_rep_name }} - {{ data.del_mode }} 
        </h3>
      </td>
    </tr>
  </thead>

  <tbody>
    <tr>
      <td>
        <div class="print-grid">
          <script type="text/javascript">
        window.onload = addPageNumbers;

        function addPageNumbers() {
            var totalPages = Math.ceil(document.body.scrollHeight / 1123);  //842px A4 pageheight for 72dpi, 1123px A4 pageheight for 96dpi, 
            for (var i = 1; i <= totalPages; i++) {
                var pageNumberDiv = document.createElement("div");
                var pageNumber = document.createTextNode(" पृष्ठ क्र. " + i + " of " + totalPages);
                pageNumberDiv.style.position = "absolute";
                pageNumberDiv.style.marginTop = "calc((" + i + " * (297mm - 0.5px)) - 40px)"; //297mm A4 pageheight; 0,5px unknown needed necessary correction value; additional wanted 40px margin from bottom(own element height included)
                pageNumberDiv.style.height = "16px";
                pageNumberDiv.appendChild(pageNumber);
                document.body.insertBefore(pageNumberDiv, document.getElementById("content"));
                pageNumberDiv.style.left = "calc(100% - (" + pageNumberDiv.offsetWidth + "px + 20px))";
            }
        }
    </script>
          <div
            class="grid-item"
            *ngFor="let item of labelsData"
          >
            <span [style.font-size.px]="item.address?.length > 84 ? 12 : 14" style="font-weight: 600;"        >
              {{ item.sub_detail }}
            </span><br />
            <span [style.font-size.px]="item.address?.length > 84 ? 12 : 14" style=" font-weight: 600;">
              {{ item.title }} {{ item.name }}
            </span><br />
            <span  [style.font-size.px]="item.address?.length > 84 ? 12 : 14" style=" font-weight: 600;">
              {{ item.address }} {{ item.taluka }}
            </span><br />
            <span [style.font-size.px]="item.address?.length > 84 ? 12 : 14" style=" font-weight: 600;">
              {{ item.district }}
            </span>
            <span  [style.font-size.px]="item.address?.length > 84 ? 12 : 14"
              style=" font-weight: 600;"
              *ngIf="item.pincode != 0"
            >
              - {{ item.pincode }} {{ item.state }}
            </span><br *ngIf="item.pincode != 0 && item.state != ''" />
            <!-- <span
             [style.font-size.px]="item.address?.length > 84 ? 12 : 13"
              style=" font-weight: 600;"
              *ngIf="item.state != ''"
            >
              {{ item.state }}
            </span><br /> -->
            <span  [style.font-size.px]="item.address?.length > 84 ? 12 : 14" style=" font-weight: 600;">
              {{ item.mobileNumber }}
            </span>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>

        <!-- <div class="header">दि. १४/०९/२३ साप्तहिक विवेक</div> -->
    </div>
</div>